import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { LineChart } from '../../../common/ui/line-chart/index.tsx';
import messages from './messages.tsx';

type CsatOverTimeProps = {
	data: {
		averageCsat: number | null;
		csatOverTime: {
			csat: number;
			month: string;
		}[];
	};
};

export const CsatOverTime = ({ data: { averageCsat, csatOverTime } }: CsatOverTimeProps) => {
	const { formatMessage } = useIntl();

	return (
		<LineChart
			data={[
				...csatOverTime.map(({ csat, month }) => ({
					name: month,
					count: csat,
				})),
			]}
			title={formatMessage(messages.title)}
			singleValue={averageCsat != null ? averageCsat.toString() : '-'}
		/>
	);
};
